<rr-filter-bar
  #filterBar
  [filterService]="collectionFilterService"
  (clearFilterValues)="clearFilterValues()"
></rr-filter-bar>
